<template>
  <div v-if="client">
    <card class="card" title="Dados do Assinante">
      <div>
        <form @submit.prevent="submit">
          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Nome"
                @keyup.native="toUpperName"
                required
                v-model="client.name"
              ></fg-input>
            </div>
            <div class="col-md-2">
              <fg-input
                type="text"
                label="CPF"
                required
                v-model="client.taxId"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="date"
                label="Data de Nasc."
                v-model="client.birthdate.split('T')[0]"
                required
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Nome da Mãe"
                @keyup.native="toUpperMotherName"
                required
                v-model="client.motherName"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="text"
                label="E-mail Financeiro"
                @keyup.native="toUpperEmail"
                required
                v-model="client.emailF"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="exampleFormControlTextarea1">Gênero</label>
                <select
                  class="form-control input i-width"
                  v-model="client.gender"
                  required
                >
                  <option :value="null" selected disabled>Selecione...</option>
                  <option value="1">Masculino</option>
                  <option value="2">Feminino</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <fg-input
                type="text"
                label="R.G /I.E"
                @keyup.native="toUpperRG"
                required
                v-model="client.identityCard"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="text"
                label="Orgão Exp. RG"
                @keyup.native="toExpSliced"
                required
                v-model="client.orgaoRG"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="exampleFormControlTextarea1"
                  >Tipo de Assinante</label
                >
                <select
                  class="form-control input i-width"
                  v-model="client.subscriberType"
                  required
                >
                  <option :value="null" selected disabled>Selecione...</option>
                  <option
                    v-for="f in field.subscriberTypes"
                    :key="`subType-${f.id}`"
                    :value="f.id"
                  >
                    {{ f.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <fg-input
                type="text"
                label="Celular"
                v-mask="'(##)#########'"
                required
                v-model="client.phone"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="text"
                label="Telefone residential"
                v-mask="'(##)#########'"
                required
                v-model="client.residentialPhone"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="text"
                label="Telefone comercial"
                v-mask="'(##)#########'"
                required
                v-model="client.commercialPhone"
              ></fg-input>
            </div>
          </div>

          <br />
          <span>Endereço do assinante</span>
          <div class="row">
            <div class="col-md-3">
              <fg-input
                type=""
                label="CEP"
                v-mask="'########'"
                required
                v-model="client.zipCode"
              ></fg-input>
            </div>

            <div class="col-md-6">
              <fg-input
                type="text"
                label="Endereço"
                @keyup.native="toUpperAddress"
                required
                v-model="client.address"
              ></fg-input>
            </div>
            <div class="col-md-2">
              <fg-input
                type="text"
                label="Número"
                required
                v-model="client.addressNumber"
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Estado(UF)"
                placeholder="Ex: SP"
                @keyup.native="toUpperState"
                v-model="client.state"
              >
              </fg-input>
            </div>

            <div class="col-md-4">
              <fg-input
                type="text"
                label="Cidade"
                @keyup.native="toUpperCity"
                required
                v-model="client.city"
              ></fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Bairro"
                @keyup.native="toUpperDistrict"
                required
                v-model="client.district"
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <fg-input
                type="text"
                label="Complemento"
                @keyup.native="toUpperAddressExtra"
                v-model="client.addressExtra"
              ></fg-input>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="exampleFormControlTextarea1">Área</label>
                <select
                  class="form-control input i-width"
                  v-model="client.area"
                  required
                >
                  <option :value="null" selected disabled>Selecione...</option>
                  <option
                    v-for="f in field.subscriberAreas"
                    :key="`subArea-${f.id}`"
                    :value="f.id"
                  >
                    {{ f.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <br />

          <div class="clearfix"></div>

          <!-- <div class="container_buttons">
            <button class="btn-custom btn-salvar">Salvar Dados</button>
          </div> -->
        </form>
      </div>
    </card>
    <hr />
    <div>
      <router-link to="cadastrar-ponto">
        <button class="btn-custom btn-salvar mb-3 mt-3">
          <i class="fa fa-plus"></i> Novo Ponto
        </button>
      </router-link>
      <button
        type="button"
        @click="showConfigModal"
        v-show="
          !client.forceAllowCreation &&
          ['admin', 'supervisor'].includes(userRole)
        "
        class="btn-custom btn-salvar"
        style="margin-left: 10px"
      >
        Liberar cadastro de ponto (exceção)
      </button>
      <button
        type="button"
        @click="toggleCreation"
        v-show="
          client.forceAllowCreation &&
          ['admin', 'supervisor'].includes(userRole)
        "
        class="btn-custom btn-interesse"
        style="margin-left: 10px"
      >
        Remover liberação de cadastro ponto (exceção)
      </button>
    </div>
    <card title="Pontos" subTitle="Pontos de internet do cliente">
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID</th>
            <th>Plano de Mensalidade</th>
            <th>Valor</th>
            <th>Desconto</th>
            <th>Valor com desconto</th>
            <th>Situação</th>
            <th>Ações</th>
          </thead>
          <tbody>
            <tr v-for="point in points" :key="`point-${point.id}`">
              <td>{{ point.id }}</td>
              <td>{{ point.plan_name }}</td>
              <td>R${{ point.price }}</td>
              <td>R${{ point.discountPrice }}</td>
              <td>R${{ point.price - point.discountPrice }}</td>
              <td>{{ formatStatus(point.status) }}</td>
              <td>
                <router-link
                  :to="`/clientes/${point.client_id}/pontos/${point.id}/atualizar-plano`"
                >
                  <p-button
                    type="success"
                    outline
                    icon
                    title="Alterar plano do ponto"
                  >
                    <i class="fa fa-pencil"></i>
                  </p-button>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
    <modal name="config" :adaptive="true" classes="modal-override">
      <p class="text-center mt-1 modal-title">
        Digite os campos abaixo para a exceção desse cliente
      </p>
      <hr />
      <form @submit.prevent="toggleCreation" class="container">
        <div class="row">
          <div class="col-md-6">
            <fg-input
              style="font-size: 20px"
              label="Valor taxa de instalação"
              type="number"
              required
              v-model="installationFee"
              step="1"
              placeholder="Digite o valor da instalação..."
            ></fg-input>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="exampleFormControlTextarea2" style="font-size: 20px"
                >Forma de pagamento</label
              >
              <select
                class="form-control input"
                v-model="paymentMethod"
                required
              >
                <option value="A vista para o instalador" selected>
                  À vista para o instalador
                </option>
                <option value="A vista boleto 5 dias">
                  À vista boleto 5 dias
                </option>
                <option value="Cartao de credito em 2 vezes">
                  Cartão de crédito em 2 vezes
                </option>
                <option value="Link de pagamento pagseguro">
                  Link de pagamento pagseguro
                </option>
                <option value="Pagamento em loja">Pagamento em loja</option>
                <option value="Isento">Isento</option>
              </select>
            </div>
          </div>
        </div>
        <button class="btn-liberar-modal">Permitir</button>
        <div class="clearfix"></div>
      </form>
      <hr style="margin-top: 20px; border: 2px #669636 solid" />
    </modal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { formatDistance } from "date-fns";
import pt from "date-fns/locale/pt-BR";
import { mapActions } from "vuex";

export default {
  name: "ViewClient",
  computed: {
    client() {
      return this.$store.getters.client;
    },
    plans() {
      return this.$store.getters.plans;
    },
    field() {
      return this.$store.getters.leadFields;
    },
    points() {
      return this.$store.getters.clientPoints;
    },
    userRole() {
      return this.$store.getters.user.role;
    },
  },
  data() {
    return {
      loading: false,
      installationFee: undefined,
      paymentMethod: "A vista para o instalador",
    };
  },
  methods: {
    showConfigModal() {
      this.$modal.show("config");
    },
    ...mapActions([
      "fetchClient",
      "fetchPlans",
      "fetchLeadFields",
      "fetchPointsByClientId",
      "createClientException",
      "deleteClientException",
    ]),
    async toggleCreation() {
      try {
        if (!this.client.forceAllowCreation) {
          await this.createClientException({
            id: this.$route.params.id,
            installationFee: Number(this.installationFee),
            paymentMethod: this.paymentMethod,
          });
          Swal.fire(
            "Sucesso!",
            "Cliente está liberado para criação de ponto (exceção) até assinar o contrato. (Essa exceção vale somente para o próximo ponto a ser gerado, caso precise para mais algum, criar aqui uma nova exceção)",
            "success"
          );
        } else {
          await this.deleteClientException({ id: this.$route.params.id });
          Swal.fire(
            "Sucesso!",
            "Cliente não está mais liberado para criação de ponto (exceção)",
            "success"
          );
        }
      } catch (err) {
        Swal.fire("Ops!", "Não foi possível liberar o cliente", "error");
      }
    },
    formatDate(date) {
      return formatDistance(date, new Date(), {
        locale: pt,
        addSuffix: true,
      });
    },
    formatStatus(value) {
      const map = new Map([
        [19, "Aguardando 1. Conexão"],
        [27, "Ativo"],
        [58, "Em aviso"],
        [43, "Bloqueado"],
        [26, "Não instalado"],
        [35, "Congelado"],
        [51, "Cancelado"],
        [52, "Cancelado inadimpl."],
        [96, "Isento"],
        [105, "Aguardando aceite"],
      ]);
      return map.get(value);
    },
    toUpperName(e) {
      this.client.name = e.target.value.toUpperCase();
    },
    toUpperMotherName(e) {
      this.client.motherName = e.target.value.toUpperCase();
    },
    toUpperRG(e) {
      this.client.rg = e.target.value.toUpperCase();
    },
    toUpperAddress(e) {
      this.client.address = e.target.value.toUpperCase();
    },
    toUpperEmail(e) {
      this.client.email = e.target.value.toUpperCase();
    },
    toUpperCity(e) {
      this.client.city = e.target.value.toUpperCase();
    },
    toUpperAddressExtra(e) {
      this.client.addressExtra = e.target.value.toUpperCase();
    },
    toUpperAddress(e) {
      this.client.address = e.target.value.toUpperCase();
    },
    toUpperState(e) {
      this.client.state = e.target.value.toUpperCase().slice(0, 2);
    },
    toExpSliced(e) {
      this.client.orgaoRG = e.target.value.toUpperCase().slice(0, 6);
    },
    toUpperDistrict(e) {
      this.client.district = e.target.value.toUpperCase();
    },
    toUpperSubject(e) {
      this.client.subject = e.target.value.toUpperCase();
    },
  },
  async mounted() {
    try {
      await Promise.all([
        this.fetchClient({ id: this.$route.params.id }),
        this.fetchPointsByClientId({ id: this.$route.params.id }),
        this.fetchPlans(),
        this.fetchLeadFields(),
      ]);
    } catch (e) {
      Swal.fire("Ops!", "Não foi possível carregar o client", "error");
    }
  },
};
</script>

<style lang="scss" scoped>
span {
  font-size: 22px;
  font-weight: bold;
}
.modal-title {
  font-size: 20px;
  padding: 10px;
  font-weight: bold;
}
button.btn-liberar-modal {
  padding: 20px 30px;
  width: 100%;
  background-color: #9dcf6b;
  border-radius: 5px;
  border: 1px solid #000;
  margin-top: 10px;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 2px;

  text-transform: uppercase;
  transition: all 1s;
}
button.btn-liberar-modal:hover {
  background-color: #669636;
}

.container_buttons {
  display: flex;
  justify-content: center;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-salvar {
    background: #9dcf6b;
    &:hover {
      background: #82ac58;
    }
  }

  &.btn-analise {
    margin-left: 10px;
    background: orange;
    &:hover {
      background: #c07e03;
    }
  }

  &.btn-gerenet {
    margin-left: 10px;
    background: #2c69c5;
    &:hover {
      background: #1e4e97;
    }
  }

  &.btn-interesse {
    margin-left: 10px;
    background: #b80a0a;
    &:hover {
      background: #700202;
    }
  }
}

@media (min-width: 768px) and (max-width: 1077px) {
  button.btn-custom.btn-interesse {
    margin-top: 20px !important;
  }
}

@media (max-width: 425px) {
  .modal-override {
    margin: auto;
    max-width: 400px;
    height: 385px !important;
  }
}
</style>
